import { IRubric, IRubricsParams, IShortItem, ITableRes } from 'types'

import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const rubricAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_rubrics: builder.query<ITableRes<IRubric>, IRubricsParams>({
      query: (params) => ({
        url: '/rubrics/',
        params,
      }),
      providesTags: ['rubrics'],
    }),
    GET_rubricSelect: builder.query<ITableRes<IShortItem>, any>({
      query: (params) => ({
        url: '/rubrics/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: ITableRes<IShortItem>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['rubric-select'],
    }),
    GET_rubricById: builder.query<IRubric, string>({
      query: (id) => {
        return {
          url: `/rubrics/${id}/`,
        }
      },
      providesTags: ['rubric'],
    }),
    POST_rubric: builder.mutation<IRubric, IRubric>({
      query: (body) => ({
        url: `/rubrics/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rubrics'],
    }),
    PATCH_rubric: builder.mutation<IRubric, { id: string; body: IRubric }>({
      query: ({ id, body }) => ({
        url: `/rubrics/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['rubrics', 'rubric'],
    }),
    DELETE_rubric: builder.mutation<IRubric, string>({
      query: (id) => ({
        url: `/rubrics/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['rubrics'],
    }),
  }),
})

export const {
  useGET_rubricSelectQuery,
  useGET_rubricsQuery,
  useGET_rubricByIdQuery,
  usePOST_rubricMutation,
  usePATCH_rubricMutation,
  useDELETE_rubricMutation,
} = rubricAPI
